import { render, staticRenderFns } from "./VPrescriptionTableRow.vue?vue&type=template&id=5aeda0f6&"
import script from "./VPrescriptionTableRow.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionTableRow.vue?vue&type=style&index=0&id=5aeda0f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports